import { Grid } from '@mui/material';
import styled from 'styled-components';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

export const LoadingContainer = styled.div`
    background-color: white;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 50px;

    > * {
        color: #015641;
    }
`;
export const GridMainContainer = styled(Grid)`
    padding: 0.5rem;
`;

export const Graphic = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-x: scroll;
    overflow-y: hidden;
    border: 1px solid #c1c1c1;
    border-radius: 7px;
    padding: 1rem;
    height: 100%;
    > h2 {
        align-self: flex-start;
        font-weight: 700;
        font-size: 24px;
        color: #25272e;
    }
    ::-webkit-scrollbar {
        border-radius: 10px;
        width: 0.7rem;
        height: 0.4rem;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #aaa;
    }

    ::-webkit-scrollbar-thumb:hover {
        border-radius: 10px;
        background: #3a6647;
    }
`;

export const GridFilter = styled(Grid)`
    height: 100%;
`;

export const GridMainContainerFilter = styled(Grid)`
    border: 1px solid #c1c1c1;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;

    > h4 {
        margin: 5px;
    }
`;

export const Divider = styled.hr`
    width: 100%;
`;

export const StackStyled = styled(Stack)`
    padding: 8px;
`;

export const ButtonStyled = styled(Button)`
    background-color: #3a6647;

    &:hover {
        background-color: #6fb283;
    }
`;
